/* eslint-disable */
module.exports = {
  omit: (obj, omitKey) => {
    return Object.keys(obj).reduce((result, key) => {
      if (key !== omitKey) {
        result[key] = obj[key];
      }
      return result;
    }, {});
  },
};



// WEBPACK FOOTER //
// ./src/utils/generalUtil.js